import React from 'react';
import { Button, Card, Form, Input } from 'antd';
import request from '@/utils/request';
import usePasswordEncrypt from "../../hooks/usePasswordEncrypt";

function UserChangePassword(props) {
  const { userInfo } = props;
  const [form] = Form.useForm();
  const formItemLayout = { labelCol: { span: 2 }, wrapperCol: { span: 6 } };
  const { changePasswordEncrypt } = usePasswordEncrypt();

  function onFinish(values) {
    changePasswordEncrypt({ ...values, username: userInfo.username }).then((newValue)=>{
      request.postWMessage('system-user-s-023', newValue);
    })

  }

  return (
    <Card
      title="修改密码"
      bordered={false}
      headStyle={{ color: '#1890ff', borderBottom: '1px solid #1890ff' }}
    >
      <Form form={form} layout="horizontal" onFinish={onFinish} {...formItemLayout}>
        <Form.Item
          label="当前密码"
          name="oPassword"
          rules={[{ required: true, message: '请输入当前密码!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="新密码"
          name="nPassword"
          dependencies={['oPassword']}
          rules={[
            { required: true, message: '请输入新密码!' },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (value && value.length < 6) {
                  return Promise.reject('密码不能小于6位');
                }
                if (value && value === getFieldValue('oPassword')) {
                  return Promise.reject('新旧密码不能相同');
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="确认密码"
          name="confirm"
          dependencies={['nPassword']}
          rules={[
            { required: true, message: '请输入确认密码!' },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (value && value.length < 6) {
                  return Promise.reject('密码不能小于6位');
                }
                if (value && value !== getFieldValue('nPassword')) {
                  return Promise.reject('您输入确认的新密码不一致, 请修改');
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 2 }}>
          <Button type="primary" htmlType="submit">
            保存修改
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default UserChangePassword;
